export default __webpack_public_path__ + "static/media/world-bank-group.6868674a.png";